import moment from 'moment';
import {
  navigateTo,
  getJsonAsync,
  postJsonAsync
} from 'shared/actions';
import {
  displayEventPriceDetailModal,
  setEventPriceDetailData
} from 'shared/eventPriceDetailsModal/actionTypes';
import {
  getShoppingCart,
  setShoppingCart
} from '../actions';
import {
  displayBirthDateModal,
  displayRequiredProfileFieldsModal,
  setAgeInState
} from '../home/actionTypes';
import {
  setNoDatesAvailable,
  updateSquadQuantity,
  updateBowlerOwnedVirtualEventQuantity,
  updateTeamOwnedVirtualEventQuantity,
  updateTotal,
  setSeletedDate,
  displayAvailableDates,
  displaySquads,
  displayVirtualEvents,
  updateSquadCountInCart,
  updateBowlerOwnedVirtualEventCountInCart,
  updateTeamOwnedVirtualEventCountInCart,
  setSelectedDate,
  displayGuideIfBundled
} from './actionTypes';
import {toastr} from 'react-redux-toastr';

export const handleSquadFeesButtonClick = (eventPrice, eventAddOnFees) => dispatch => {
  dispatch(displayEventPriceDetailModal());
  dispatch(setEventPriceDetailData(eventPrice, eventAddOnFees));
};

export const updateTotalFromLocalStorage = () => dispatch => dispatch(updateTotal(getShoppingCart()));

export const updateSquadInLocalStorage = (squadId, quantity) => (dispatch, getState) => {
  const registrationState = getState().registration,
    events = registrationState.scheduler.events,
    tournamentId = registrationState.base.tournamentId;

  let shoppingCart = getShoppingCart(),
    items = shoppingCart.squads.filter(x => x.id === squadId),
    item = items.length ? items[0] : null;

  if(item) {
    item.quantity += Number(quantity);
  } else {
    let squad = null;

    for(let event of events) {
      squad = event.squads.find(({id}) => id === squadId);
      if(squad) {break;}
    }
    if(!squad) {
      throw new Error(`Squad ${squadId} not found in state`);
    }
    shoppingCart.squads.push({
      ...squad,
      quantity
    });
  }

  dispatch(setShoppingCart(shoppingCart, tournamentId));
};

export const clearSquadQuantity = squadId => dispatch =>
  dispatch(updateSquadQuantity({
    squadId,
    addedToCart: true,
    inputValue: 0,
    max: 0
  }));

export const updateSquadCartCount = (squadId, quantity) => dispatch =>
  dispatch(updateSquadCountInCart(squadId, quantity));

export const handleEventSquadAddClick = (squadId, quantity) => (dispatch, getState) => {
  const regState = getState().registration,
    tournamentId = regState.base.tournamentId,
    events = regState.scheduler.events,
    selectedDate = regState.scheduler.calendar.selectedDate;

  let bundledParentNumberOfBowlers = false; // hack: want to use isLinked but not set properly
  let squadsInCart = 0;  

  events.forEach(event => {
    if (event.bundledParentNumberOfBowlers) {
      bundledParentNumberOfBowlers = true;
    }
    event.squads.forEach(squad => {
      if (squad.quantity > 0 || (squad.countInCart && squad.countInCart > 0)) {
          squadsInCart += 1;        
      }
    });    
  });

  dispatch(getJsonAsync(`tournament/${tournamentId}/bundling`))
  .then((squadBundling) => {
    if (squadBundling === true && squadsInCart > 1 && !bundledParentNumberOfBowlers) {
      toastr.warning('2nd Team Purchase', 'Teams can only be purchased for one squad time per day per order. To register for multiple team squad times on the same day, please process separate orders.');
      dispatch(updateSquadQuantity({
        squadId,
        addedToCart: false,
        inputValue: 0,
        max: 0
      }));
    } else {
      dispatch(updateSquadCartCount(squadId, quantity));
      dispatch(updateSquadInLocalStorage(squadId, quantity));
      dispatch(updateTotal(getShoppingCart()));
      dispatch(clearSquadQuantity(squadId));
      dispatch(displayGuideIfBundled(squadId));
      toastr.success('Added to Cart!', 'Your selection was added to the cart.');
      dispatch(retrieveAvailableDates(tournamentId))
      .then(() => dispatch(setSeletedDate(selectedDate)));
    }
  });
};

export const handleDateSelection = selectedDate => dispatch => {
  // infinite-calendar uses moment for selected date
  let formattedDate = selectedDate; 
  
  if (typeof(selectedDate) !== 'string')
    formattedDate = selectedDate.format('YYYY-MM-DD');
 
  dispatch(retrieveSquads(formattedDate));
  dispatch(setSelectedDate(formattedDate));
}; 

export const resetInformation = () => dispatch => {
  dispatch(setNoDatesAvailable(false));
  dispatch(displayAvailableDates({visible: false}));
  dispatch(displaySquads({
    events: [],
    cart: getShoppingCart()
  }));
};

export const checkRestrictions = tournamentId  => (dispatch, getState) => new Promise((resolve, reject) => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/restriction`))
  .then((restrictions) => {
    const authState = getState().shared.auth;
    let enforceMinimumCaptainAge = restrictions ? restrictions.enforceMinimumCaptainAge : false; 
    let dobRaw = authState.dob;

    if (!authState.profileIsConfirmed)
    {
      dispatch(navigateTo('registration'));
      reject('NeedToConfirmProfile');
      return;
    } else if (!authState.profileIsValid)
    {
      dispatch(navigateTo('registration'));
      dispatch(displayRequiredProfileFieldsModal(true));
      reject('MissingRequiredProfileFields');
      return;
    }
    
    if (enforceMinimumCaptainAge) {
      dispatch(setAgeInState(restrictions.minimumCaptainAge));
       
      let dob = new Date(dobRaw);
      let verificationDate = Date.now();
      let age = moment.duration(verificationDate - dob).years(); 

      if (age < restrictions.minimumCaptainAge) {
        dispatch(navigateTo('registration'));
        dispatch(displayBirthDateModal(true));
        reject('MinimumCaptainAgeFailed');
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
});

export const retrieveAvailableDates = tournamentId => dispatch => new Promise((resolve, reject) => {
  dispatch(postJsonAsync(`registration/tournament/${tournamentId}/dates`, getShoppingCart()))
  .then(data => {
    if(data) {
      dispatch(displayAvailableDates({
        disabledDates: data.disabledDates.map(item => moment.parseZone(item).format('YYYY-MM-DD')),
        min: moment.parseZone(data.firstAvailableSquadDate).startOf('month').format('YYYY-MM-DD'),
        minDate: moment.parseZone(data.firstAvailableSquadDate).format('YYYY-MM-DD'),
        max: moment.parseZone(data.lastAvailableSquadDate).endOf('month').format('YYYY-MM-DD'),
        maxDate: moment.parseZone(data.lastAvailableSquadDate).format('YYYY-MM-DD'),
        selectedDate: null,
        visible: true
      }));
    } else {
      dispatch(setNoDatesAvailable(true));
    }
    resolve(data);
  })
  .catch(error => reject(error));
});

export const handleBowlerOwnedVirtualEventAddClick = virtualEvent => (dispatch, getState) => {
  let shoppingCart = getShoppingCart(),
    items = shoppingCart.virtualEvents.filter(x => x.id === virtualEvent.id),
    item = items.length ? items[0] : null,
    tournamentId = getState().registration.base.tournamentId;

  if(item) {
    item.quantity += virtualEvent.quantity;
  } else {
    shoppingCart.virtualEvents.push(virtualEvent);
  }

  dispatch(updateBowlerOwnedVirtualEventCountCart(virtualEvent.id, virtualEvent.quantity));
  dispatch(setShoppingCart(shoppingCart, tournamentId));
  dispatch(updateTotal(shoppingCart));
  dispatch(updateBowlerOwnedVirtualEventQuantity(virtualEvent.id, 0)); // clear quantity field after adding to cart
  toastr.success('Added to Cart!', 'Your selection was added to the cart.');
};

export const handleTeamOwnedVirtualEventAddClick = virtualEvent => (dispatch, getState) => {
  let shoppingCart = getShoppingCart(),
    items = shoppingCart.virtualEvents.filter(x => x.id === virtualEvent.id),
    item = items.length ? items[0] : null,
    tournamentId = getState().registration.base.tournamentId;

  if(item) {
    item.quantity += virtualEvent.quantity;
  } else {
    shoppingCart.virtualEvents.push(virtualEvent);
  }

  dispatch(updateTeamOwnedVirtualEventCountCart(virtualEvent.eventId, virtualEvent.id, virtualEvent.quantity));
  dispatch(setShoppingCart(shoppingCart, tournamentId));
  dispatch(updateTotal(shoppingCart));
  dispatch(updateTeamOwnedVirtualEventQuantity(virtualEvent.eventId, virtualEvent.id, 0)); // clear quantity field after adding to cart
  toastr.success('Added to Cart!', 'Your selection was added to the cart.');
};

export const retrieveSquads = selectedDateString => (dispatch, getState) => {
  const {tournamentId} = getState().registration.base;
  const shoppingCart = getShoppingCart();

  dispatch(postJsonAsync(`registration/tournament/${tournamentId}/event/squad/${selectedDateString}`, shoppingCart))
  .then(data => dispatch(displaySquads({
    events: data,
    cart: shoppingCart
  })));
};

export const retrieveVirtualEvents = (tournamentId, captainView = true) => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/virtualevents?captainView=${captainView}`))
  .then(virtualEvents => dispatch(displayVirtualEvents({ 
    virtualEvents: virtualEvents,
    cart: getShoppingCart()
  })));
};

export const checkout = () => (dispatch, getState) => {
  const {tournamentId, requireRosterBeforeCheckout} = getState().registration.base;

  dispatch(navigateTo(requireRosterBeforeCheckout ? `registration/rostercheckout/${tournamentId}` : `registration/checkout/${tournamentId}`));
};

export const updateBowlerOwnedVirtualEventCountCart = (virtualEventId, quantity) => dispatch =>
  dispatch(updateBowlerOwnedVirtualEventCountInCart(virtualEventId, quantity));

export const updateTeamOwnedVirtualEventCountCart = (eventId, virtualEventId, quantity) => dispatch =>
  dispatch(updateTeamOwnedVirtualEventCountInCart(eventId, virtualEventId, quantity));



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/actions.js